__turbopack_context__.v({
  "iframe": "BackgroundVideo-module__gFGWBa__iframe",
  "poster": "BackgroundVideo-module__gFGWBa__poster",
  "posterHidden": "BackgroundVideo-module__gFGWBa__posterHidden",
  "root": "BackgroundVideo-module__gFGWBa__root",
  "video": "BackgroundVideo-module__gFGWBa__video",
});
